<script lang="ts">
	import type { Writable, Readable } from "svelte/store";
import MainSearch  from './MainSearch.svelte'
	import { onMount } from "svelte";
	import Search from "./Search.svelte";
	export let mobileMenuVizStore: Writable<boolean>;
	export let desktopSearchVizStore: Writable<boolean>;
	// export let divisionsMainMenuVizStore: Writable<boolean>
	let mainmenu = document.getElementById("com-main-menu");
	let searchDom = document.getElementById("com-header");
	let clickCount = 0;
	let SearchInstance;
	function toggleMainMenu(e: Event) {
		clickCount++;

		if (clickCount === 1) {
			// Prevent propagation on the first click
			e.stopPropagation();
			mainmenu?.classList.add("show");
		} else if (clickCount === 2) {
			// Allow propagation on the second click
			mainmenu?.classList.remove("show");
			clickCount = 0; // Reset the counter
		}
	}
	// export let isDivision = false
	let isHomePage = false;
	function handleMobileToggle(e: Event) {
		e.stopPropagation();
		e.stopImmediatePropagation();
		$mobileMenuVizStore = !$mobileMenuVizStore;
	}
	onMount(function hideMainNav() {
	switch (document.getElementById("department-navigation")) {
		case null:
			isHomePage = true;
			break;
		default:
			isHomePage = false;
			break;
	}
		
	});
</script>

<div id="header-button-container" class="flex">
	<button
		id="global-search"
		aria-label="Search toggle"
		on:click={() => 
		 
		{
			$desktopSearchVizStore = !$desktopSearchVizStore;
        if ($desktopSearchVizStore) {
            // Target the input field within .main-search-container and set focus
            setTimeout(() => {
                const searchInput = document.querySelector('.main-search-container input[type="text"]');
                if (searchInput) {
                    searchInput.focus();
                    // Move the cursor to the end of the input field
                    const length = searchInput.value.length;
                    searchInput.setSelectionRange(length, length);
                }
            }, 100);
        }
    }}>
		<i class="fa-duotone fa-magnifying-glass"></i>
	</button>
	<button
		id="mobile-menu-toggle"
		aria-label="Menu toggle"
		on:click={handleMobileToggle}
	>
		<i class="fa-duotone fa-bars-staggered"></i>
	</button>
	{#if !isHomePage}
		<button
			id="desktop--main-menu-toggle"
			aria-label="Main Menu toggle"
			on:click={toggleMainMenu}
		>
			<i class="fa-duotone fa-bars-staggered"></i>
		</button>
	{/if}
</div>

<style lang="scss">
	button#global-search {
		display: none;

		@media (min-width: 1385px) {
			display: block;
		}
	}
	button#mobile-menu-toggle {
		display: block;

		@media (min-width: 1385px) {
			display: none;
		}
	}
	button#desktop--main-menu-toggle {
		display: block;

		@media (width <= 1384px) {
			display: none;
		}
	}
</style>
